<template>
  <div class="videoOuter">
    <div class="header">
      <div class="left">
        <img src="../assets/image/searchShop.png" alt />
        <div class="title">
          <p>探店吃喝玩乐</p>
          <p>100万人已下载</p>
        </div>
      </div>
      <button class="right" @click="openApp">打开看看</button>
    </div>
    <div class="content">
      <div class="bg">
        <img :src="data.coverUrl" />
      </div>
      <div class="info">
        <div class="photo"><img :src="data.headUrl" /></div>
        <div class="name">@{{data.nickName}}</div>
        <div class="title">{{data.title}}</div>
      </div>
    </div>
    <div class="footer">
      更多精彩请前往客户端体验
    </div>
    <div class="footerContent">
      <div class="contentLeft">
        <!-- <img src="../assets/image/searchlogo.png" alt /> -->
        <img class="tdLogo" src="../assets/image/tdLogo.png" />
        <img class="tdName" src="../assets/image/tdName.png" />
        <span>发现好店，分享美好生活</span>
      </div>
      <button @click="openApp">立即加入</button>
    </div>
  </div>
</template>
<script>
import wx from "weixin-js-sdk";
import {getOnliveInfo,shareSign,androidUrl} from '@/api'
export default {
  name: "SearchShop",
  props: {
    msg: String
  },
  updated() {},
  data() {
    return {
      data: {},
      andiorUrl: "",
      isShow: false,
      id:'',
      url: ''
    };
  },
  created() {
    this.id = this.$route.query.id; // 探店吃喝玩乐号
    const params = {
      id: this.id
    }
    getOnliveInfo(params).then(res => {
      const { code,data } = res;
      if (code === "200") {
        this.data = data;
      }else if(code === '40001'){
        this.$toast('该直播不存在')
      }
    })
  },
  mounted() {
    this.video = document.getElementById("video");
    // const ua = window.navigator.userAgent.toLowerCase();
    // if(ua.match(/MicroMessenger/i) == 'micromessenger'){
      const shareUrl = window.location.href.split('#')[0]
      this.url = shareUrl
      const formData = new FormData();
      formData.append("urla", shareUrl);
      shareSign(formData).then(res => {
        const { code, data } = res;
        if (code === '200') {
          this.shareMessage(data)
        }
      })
    // }
  },
  methods: {
    // 点击打开app
    openApp() {
      if (navigator.userAgent.match(/(iPhone|iPod|iPad);?/i)) {
        window.location.href = 'tandian://';
        setTimeout(function(){
          let hidden = window.document.hidden || window.document.mozHidden || window.document.msHidden ||window.document.webkitHidden 
          if(typeof hidden =="undefined" || hidden ==false){
            //App store下载地址
              window.location.href = "https://apps.apple.com/app/id1527402524";
          }
        }, 1000);
        return false;
        // var loadDateTime = new Date();
        // window.location.href = "tandian://"; //schema链接或者universal link
        // window.setTimeout(function() {
        //   //如果没有安装app,便会执行setTimeout跳转下载页
        //   var timeOutDateTime = new Date();
        //   if (timeOutDateTime - loadDateTime < 5000) {
        //     window.location = "https://apps.apple.com/app/id1527402524"; //ios下载地址
        //   } else {
        //     window.close();
        //   }
        // }, 500);
      } else if (navigator.userAgent.match(/android/i)) {
        try {
          window.location = "tandian://"; //schema链接或者universal linky
          window.setTimeout(()=> {
            if (this.andiorUrl === '' || this.andiorUrl === undefined) {
              this.getAndiorUrl()
            } else {
              window.location.href = this.andiorUrl //android下载地址
            }
          }, 500);
        } catch (e) {
          console.log(e);
        }
      }
    },
    getAndiorUrl () {
      androidUrl().then(res => {
        const { code, data } = res;
        if (code === '200') {
          this.shareMessage(data)
          this.andiorUrl = data.packageUrl
          window.location.href = this.andiorUrl //android下载地址
        }
      })
    },
    shareMessage(res) {
      wx.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: res.appId, // 必填，公众号的唯一标识
        timestamp: res.timestamp, // 必填，生成签名的时间戳
        nonceStr: res.nonceStr, // 必填，生成签名的随机串
        signature: res.signature, // 必填，签名
        jsApiList: [
          "updateAppMessageShareData", // 获取“分享到朋友圈”按钮点击状态及自定义分享内容接口
          "onMenuShareAppMessage" // 获取“分享给朋友”按钮点击状态及自定义分享内容接口
        ] // 必填，需要使用的JS接口列表
      });
      wx.checkJsApi({
        jsApiList: ["updateAppMessageShareData", "onMenuShareAppMessage"], // 需要检测的JS接口列表，所有JS接口列表见附录2,
        success: function() {}
      });
      wx.ready(()=> {
        wx.updateAppMessageShareData({
          title: this.data.nickName, // 分享标题
          desc: this.data.title, // 分享描述
          link: this.url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: this.data.coverUrl, // 分享图标
          success: function() {
            // 设置成功
            console.log("分享成功");
          }
        })
        wx.error(function(res){
          console.log(res)
        })
      })
    }
  }
};
</script>

<style lang="scss" scoped>
.videoOuter {
  font-family: PingFang SC;
  overflow: hidden;
  width: 100%;
  margin: 0 auto;
  min-height: 100%;
  background: #eee;
  position: absolute;
  .header {
    box-sizing: border-box;
    width: 100%;
    position: fixed;
    background: #fff;
    z-index: 2;
    top: 0;
    height: 136px;
    display: flex;
    justify-content: space-between;
    padding: 0 30px;
    align-items: center;
    .left {
      display: flex;
      img {
        width: 68px;
        height: 86px;
      }
      .title {
        margin: 17px 0 0 24px;
        p:nth-child(1) {
          font-size: 30px;
          font-weight: bold;
          color: rgba(51, 51, 51, 1);
        }
        p:nth-child(2) {
          font-size: 22px;
          font-weight: 500;
          color: rgba(153, 153, 153, 1);
        }
      }
    }
    .right {
      background: rgba(234, 65, 73, 1);
      border-radius: 6px;
      font-size: 26px;
      font-weight: 500;
      color: rgba(255, 255, 255, 1);
      border: none;
      padding: 16px 44px;
    }
  }
  .content {
    height: 970px;
    width: 100%;
    position: relative;
    overflow: hidden;
    margin-top: 136px;
    &::after{
      content: '';
      width:100%;
      height:100%;
      background: rgba(0, 0, 0, 0.7);
      position: absolute;
      top:0;
      left:0;
      z-index: 1;
    }
    .bg{
      width:100%;
      height: 100%;
      img{
        width:100%;
        height:100%;
        filter: blur(10px); 
      }
    }
    .info {
      width: 100%;
      position: absolute;
      top: 280px;
      text-align: center;
      z-index: 2;
      .photo{
        width:145px;
        height: 145px;
        background: #fff;
        margin: 0 auto;
        border-radius: 50%;
        overflow: hidden;
        border:1px solid #fff;
        img{
          width:100%;
        }
      }
      .name{
        font-size:32px;
        font-weight:500;
        color:rgba(255,255,255,1);
        line-height:22px;
        margin: 27px 0 33px;
      }
      .title{
        color:rgba(235,235,235,1);
        line-height:22px;
        font-size: 26px;
      }
    }
  }
  .more {
    overflow: hidden;
    width: 100%;
    display: flex;
    display: -webkit-flex;
    display: -webkit-box;
    li {
      float: left;
      position: relative;
      margin-right: 4px;
      img {
        width: 288px;
        height: 298px;
      }
      .morePlay {
        position: absolute;
        left: 108px;
        top: 108px;
        width: 74px;
        height: 82px;
      }
    }
  }
  .footer {
    display: flex;
    justify-content: center;
    height: 95px;
    line-height: 95px;
    font-size: 24px;
    font-weight: 400;
    color: rgba(153, 153, 153, 1);
  }
  .footerContent {
    width:100%;
    padding: 32px 30px;
    display: flex;
    justify-content: space-between;
    position: fixed;
    bottom:0;
    left:0;
    box-sizing: border-box;
    background: #fff;
    z-index: 999;
    .contentLeft {
      .tdLogo{
        width: 45px;
        height: 45px;
        vertical-align: bottom;
      }
      .tdName{
        width: 130px;
        height: 24px;
        margin-left: 10px;
        vertical-align: center;
      }
      span {
        display: inline-block;
        padding: 4px 15px;
        margin-left: 17px;
        border-left: 1px solid rgba(153, 153, 153, 1);
        font-size: 26px;
        font-weight: 500;
        color: rgba(161, 161, 161, 1);
      }
    }
    button {
      padding: 14px;
      border: none;
      background: rgba(25, 25, 25, 1);
      border-radius: 6px;
      color: #fff;
      font-size: 26px;
      font-weight: 500;
    }
  }
  .maskOuter {
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    background: rgba(0, 0, 0, 0.3);
    z-index: 10;
    .mask {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translateX(-50%) translateY(-50%);
      background: aliceblue;
    }
  }
}
</style>
